(function() {
    'use strict';

    angular
        .module("showcaseApp")
        .component("styledTextArea", {
            templateUrl: "app/components/styled-text-area/styled-text-area.html",
            controller: styledTextAreaController,
            bindings: {
                labelKey: "@",
                model: "=",
                name: "@",
                minLength: "@",
                maxLength: "@",
                required: "<",
                errors: "<",
                placeholder: "@",
                form: "<",
                rows: "<"
            },
        });

    /** @ngInject */
    function styledTextAreaController() {
        var $ctrl = this;

        $ctrl.errors = $ctrl.errors || {
            required: 'entity.validation.required',
            minlength: 'entity.validation.minlength',
            maxlength: 'entity.validation.maxlength'
        };
    }
})();
